import { getBodyClientRect } from '@/utils/dom'

const baseWidth = 595
export const calcRatio = () => {
  const { clientWidth } = getBodyClientRect()
  return clientWidth / baseWidth
}
